"use strict";
// Generated by https://quicktype.io
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dex = exports.DataFeed = void 0;
var DataFeed;
(function (DataFeed) {
    DataFeed[DataFeed["Chainlink"] = 0] = "Chainlink";
    DataFeed[DataFeed["Twap"] = 1] = "Twap";
})(DataFeed = exports.DataFeed || (exports.DataFeed = {}));
var Dex;
(function (Dex) {
    Dex[Dex["Uniswap"] = 0] = "Uniswap";
    Dex[Dex["Apeswap"] = 1] = "Apeswap";
    Dex[Dex["Pancakeswap"] = 2] = "Pancakeswap";
})(Dex = exports.Dex || (exports.Dex = {}));
//# sourceMappingURL=strategyQueryData.js.map